<template>
    <div class="deliveries">
        <div class="box-white-wrapper">
          <vs-table :data="routes" pagination search max-items="50">
                <template slot="header" v-if="userInfoData.role == Roles.Admin">
                    <vs-button color="primary" to="/routes/create" type="border" icon="library_add" style="margin-right: 15px">Crear Ruta</vs-button>
                </template>
                <template slot="thead">
                    <vs-th sort-key="id">Id</vs-th>
                    <vs-th sort-key="comments">Nombre</vs-th>
                    <vs-th sort-key="assignedTo">Asignada </vs-th>
                    <vs-th sort-key="statusName">Estado </vs-th>
                    <vs-th sort-key="createdAt"> Fecha </vs-th>
                    <vs-th sort-key="id" class="width-30"></vs-th>
                </template>
              <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                    <vs-td :data="data[indextr].id">{{data[indextr].id }}</vs-td>
                    <vs-td :data="data[indextr].notes">{{data[indextr].comments }}</vs-td>
                    <vs-td :data="data[indextr].applicant">{{data[indextr].assignedTo }}</vs-td>
                    <vs-td :data="data[indextr].applicant">{{data[indextr].statusName }}</vs-td>
                    <vs-td :data="data[indextr].createdAt">{{data[indextr].createdAt | moment('lll') }}</vs-td> 
                    <vs-td :data="data[indextr].id">
                        <div class="table-actions" v-if="userInfoData.role != Roles.Distribuitor">
                            <router-link :to="`/route/${data[indextr].id}`"><feather type="eye"/></router-link>
                        </div>
                    </vs-td>
                  </vs-tr>
              </template>
          </vs-table>
        </div>
    </div>
</template>
<script>
import { mapState, } from 'vuex'
import { Role } from '@/helpers/Role.js'
import DeliveryService from "@/services/DeliveryService"
export default {
    name: 'ViewDeliveries',
    data () {
        return {
            routes: [],
            roles: []
        }
    },
    computed: {
        ...mapState(['userInfoData']),
    },
    created() {
        this.Roles = Role
        if(this.Roles.Admin != this.userInfoData.role){
            this.$router.push({ name: "Home"})
            this.$vs.notify({title:'Información!',text:'Acceso denegado!',color:'danger',icon:'error_outline'})
        }
    },
    beforeMount() {
        this.$Progress.start();
    },
    mounted (){
        this.getRoutes();
    },
    methods: {
        getRoutes() {
            DeliveryService.getRoutes()
            .then(response => {
                console.log(response);
                this.routes = response.data.records;
                this.$Progress.finish()
            })
            .catch( () => {
                this.$Progress.finish()
            });
        }
    }
}
</script>